import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ButtonComponent, IconComponent } from '@rivet-health/design-system';
import { BehaviorSubject } from 'rxjs';
import { AnchoredPosition } from './callout-position';

@Component({
  selector: 'button-dropdown',
  templateUrl: './button-dropdown.component.html',
  styleUrls: ['./button-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonDropdownComponent {
  @Input()
  locked: boolean;

  @Input()
  disabled: boolean;

  @Input()
  hideTooltip: boolean;

  @Input()
  hideLock: boolean;

  @Input()
  size: ButtonComponent.Size = 'medium';

  @Input()
  buttonType: ButtonComponent.Variant = 'basic';

  @Input()
  onDark: boolean;

  @Input()
  loading: boolean;

  @Input()
  active: boolean;

  @Input()
  full: boolean;

  @Input()
  icon?: IconComponent.Name;

  @Input()
  iconPosition: ButtonComponent.IconPosition = 'first';

  @Input()
  preferredPosition = AnchoredPosition.BOTTOM_RIGHT;

  @Input()
  submitFormOnClick: boolean = true;

  @Input()
  topAndBottomPositionsOnly: boolean = false;

  @Input()
  scrollableCallout: boolean = true;

  @Output()
  readonly click = new EventEmitter();

  @Output()
  readonly isOpen = new BehaviorSubject<boolean>(false);

  public close() {
    this.isOpen.next(false);
  }

  public open() {
    this.isOpen.next(true);
  }

  @ViewChild('anchor', { static: false, read: ElementRef })
  anchorRef: ElementRef<HTMLElement>;
  get anchorWidth() {
    return this.anchorRef.nativeElement.offsetWidth;
  }

  readonly allowedPositions = [
    AnchoredPosition.BOTTOM_RIGHT,
    AnchoredPosition.BOTTOM_LEFT,
    AnchoredPosition.TOP_RIGHT,
    AnchoredPosition.TOP_LEFT,
    AnchoredPosition.CENTER_LEFT,
    AnchoredPosition.CENTER_RIGHT,
  ];

  readonly topAndBottomPositions = [
    AnchoredPosition.BOTTOM_RIGHT,
    AnchoredPosition.BOTTOM_LEFT,
    AnchoredPosition.TOP_RIGHT,
    AnchoredPosition.TOP_LEFT,
  ];
}
